import { Component, Input, OnInit } from '@angular/core';
import { SharedService } from 'src/app/core/services/shared.service';

@Component({
  selector: 'app-echart',
  templateUrl: './echart.component.html',
  styleUrls: ['./echart.component.scss']
})

export class EchartComponent implements OnInit {
  strEchartWS : string = "api/charts/ViewChart/";
  
  @Input() arrFiltros = "";
  @Input() SYS33CON   : number;

  // Id del gráfico a pintar
  @Input() strSYS35COD : string = '';
  @Input() strSYS35URL : string = '';

  // Refrescar
  @Input() blnRefresh : boolean = true;

  // Objeto JSON del gráfico
  strJson_Chart : any;

  constructor(private dataService: SharedService) {
  }
  
  ngOnInit(): void {
  }

  ngOnChanges() {
    this.Graficar();
  }

  Graficar() {
    console.log(this.arrFiltros, 'arr filtros');
    
    if (this.strSYS35URL == '') this.strSYS35URL = this.strEchartWS;
    let strjson = "{      \"FILTROS_OPCIONALES\"   : []" +
                      " , \"SYS33CON\"             : \"" + this.SYS33CON   + "\" " +    
                      " , \"FILTROS_DASHBOARD\"    : [" + this.arrFiltros + "]" +
                      " , \"FILTROS_OBLIGATORIOS\" : [" + JSON.stringify("") + "]}";
    console.log(strjson, 'strjson');
    
    let arr = JSON.parse(strjson);
    console.log (arr);

    this.dataService.ConsultarWS(this.strSYS35URL+this.strSYS35COD, JSON.stringify(arr)).subscribe((datos: any) => {
      console.log (atob(datos.DATA[0].CHART_OPTIONS));
      this.strJson_Chart = JSON.parse(atob(datos.DATA[0].CHART_OPTIONS));  
    });        
  }


}
